export default __webpack_public_path__ + "static/azure_ad-31a088e8a7c1276661b7d859912acb6c.png";